import axios, {AxiosRequestConfig} from "axios";
import mustache from 'mustache';
import toastify from "../../../common/toastify";


export const http = axios.create({
    baseURL: `${process.env.REACT_APP_API_CONTEXT}`,
    timeout: 300000
});

function RestApi(basePath: string) {

    async function post(uriTemplate: string, pathArgs: any, body: any, queryArgs?: any, headers?: any, timeout?: number) {
        uriTemplate = basePath + uriTemplate;
        const uri = pathArgs ? mustache.render(uriTemplate, pathArgs) : uriTemplate;

        const config: AxiosRequestConfig = {params: queryArgs || {}};
        if (headers) {
            config.headers = headers;
        }
        if (timeout) {
            config.timeout = timeout;
        }
        return http.post(uri, body, config)
            .then((response: any) => {
                if (response.status === 201) {
                    const location = response.headers.location;
                    if (location) {
                        return location;
                        // const lastIndex = location.lastIndexOf("/");
                        // if (lastIndex !== -1) {
                        //     const id = location.substring(lastIndex + 1);
                        //     return id;
                        // }
                        // }else{
                        //     return response;
                        // }
                    }
                } else if (response.status === 200) {
                    return response.data;
                }
            }).catch((error: any) => {
                console.error(JSON.stringify(error.response.data));
                throw error
                // throw    new Error(error);
            });
    }

    async function put(
        uriTemplate: string,
        pathArgs: any,
        body?: any,
        queryArgs?: any,
        headers?: any
    ) {
        uriTemplate = basePath + uriTemplate;
        const uri = pathArgs ? mustache.render(uriTemplate, pathArgs) : uriTemplate;

        const config: AxiosRequestConfig = {
            params: queryArgs || {},
            headers: headers || {}
        };

        return http.put(uri, body, config)
            .catch((error: any) => {
                console.error(JSON.stringify(error.response.data));
                throw error;
            });
    }

    async function get(uriTemplate: string, pathArgs?: any, queryArgs?: any, headers?: any) {
        uriTemplate = basePath + uriTemplate;
        const uri = pathArgs ? mustache.render(uriTemplate, pathArgs) : uriTemplate;
        let data: any = localStorage.getItem("token");
        data = data ? JSON.parse(data) : '';
        return http.get(uri, {params: queryArgs || {}, headers: headers || {}})
            .then((response: any) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    let error = {code: 'http.get.error', message: `Http GET [${uri}] failed with ${response.status}`};
                    throw error;
                }
            }).catch((error: any) => {
                console.error(JSON.stringify(error?.response?.data));
                throw error;
            });
    }

    async function fetchData(uriTemplate: string, pathArgs?: any, queryArgs?: any) {
        uriTemplate = basePath + uriTemplate;
        const uri = pathArgs ? mustache.render(uriTemplate, pathArgs) : uriTemplate;
        let data: any = localStorage.getItem("token");
        data = data ? JSON.parse(data) : '';
        return http.get(uri, {
            params: queryArgs || {},
            responseType: 'blob'
        })
            .then((response: any) => {
                if (response.status === 200) {
                    return response.data;
                } else {
                    let error = {code: 'http.get.error', message: `Http GET [${uri}] failed with ${response.status}`};
                    throw error;
                }
            }).catch((error: any) => {
                console.error(JSON.stringify(error?.response?.data));
                throw error;
            });
    }

    async function del(uriTemplate: string, pathArgs: any, body?: any, queryArgs?: any) {
        uriTemplate = basePath + uriTemplate;
        const uri = pathArgs ? mustache.render(uriTemplate, pathArgs) : uriTemplate;

        if (body) {
            // console.log(JSON.stringify(body))
        }
        return http.delete(uri, {data: body, params: queryArgs || {}})
            .then((response: any) => {
                toastify({title: response.statusText, message: "Item Deleted Successfully", isSuccessful: true})
            })
            .catch((error: any) => {
                if (error.response.status === 410)
                    return
                console.error(JSON.stringify(error.response.data));
                throw error;
            });
    }

    return {
        get,
        post,
        del,
        put,
        fetchData,
        http
    };
}

export const hrms = RestApi("");
export const hrmsWithPath = (path: string) => RestApi(path);
